document.addEventListener("DOMContentLoaded", function () {
  const countdown = document.getElementById("countdown");
  const countDownDate = new Date("Oct 15, 2023 00:00:00").getTime();

  if (countdown) {
    const countdownInterval = setInterval(function () {
      const now = new Date().getTime();
      const distance = countDownDate - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        clearInterval(countdownInterval);
        countdown.innerHTML = "STONE CRAB SEASON IS NOW ACTIVE";
      } else {
        document.getElementById("countdown-text").style.display = "inline-block";
        document.querySelectorAll("#countdown div").forEach(function (el) {
          el.style.display = "inline-block";
        });

        document.getElementById("days").innerHTML = `${days} <span>days</span>`;
        document.getElementById("hours").innerHTML = `${hours} <span>hrs</span>`;
        document.getElementById("minutes").innerHTML = `${minutes} <span>min</span>`;
        document.getElementById("seconds").innerHTML = `${seconds} <span>sec</span>`;
      }
    }, 1000);
  }

  const el = document.querySelector('#banner-message > div > h5:nth-child(1) > a');
  if (el) {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      window.alia = window.alia || [];
      window.alia.push({
        type: "open",
        campaignID: 2969,
        ignoreTargeting: true
      });
    });
  }

/* Add Read More buttons */
  document.querySelectorAll('.single-article').forEach(function (article) {
    const body = article.querySelector('.article-body');
    if (!body) return;

    const titleLink = body.querySelector('h3 a');
    if (!titleLink) return;

    const cta = document.createElement('div');
    cta.className = 'cta';

    const btn = document.createElement('a');
    btn.className = 'blog-read-more-btn';
    btn.href = titleLink.href;
    btn.textContent = 'Read More';

    cta.appendChild(btn);
    body.appendChild(cta);
  });

  /* ---- SHOP NOW BUTTONS ---- */
  function addShopNow() {
    const products = document.querySelectorAll('.related-product-loop .product, .product-recommendations .product, #main-collection-product-grid .product-index');
    if (!products.length) return false;

    products.forEach(function (prod) {
      const details = prod.querySelector('.product-details');
      if (!details) return;

      const link = details.querySelector('.js-product-details-link');
      if (!link) return;

      // Skip if button already exists
      if (details.querySelector('.shop-now-btn')) return;

      const cta = document.createElement('div');
      cta.className = 'cta';

      const btn = document.createElement('a');
      btn.className = 'shop-now-btn';
      btn.href = link.href;
      btn.textContent = 'Shop Now';

      cta.appendChild(btn);
      details.appendChild(cta);
    });

    return true;
  }

  // Handle product recommendations
  const recWrapper = document.querySelector('.js-product-rec-wrapper');
  if (recWrapper) {
    const observer = new MutationObserver(function (mutations) {
      if (addShopNow()) {
        observer.disconnect();
      }
    });
    observer.observe(recWrapper, { childList: true, subtree: true });
  }

  // Handle collection grid on page load
  addShopNow();

  // Handle infinite scroll for collection grid
  const collectionGrid = document.querySelector('#main-collection-product-grid[data-collection-infinite-scroll]');
  if (collectionGrid) {
    const scrollObserver = new MutationObserver(addShopNow);
    scrollObserver.observe(collectionGrid, { childList: true });
  }
});


/**
 * Mobile Slider - Gallery & Blog Sections
 * Initializes Swiper on pre-built mobile slider markup
 */

(function() {
  const BREAKPOINT = 600;
  
  let swipers = [];
  
  // Load Swiper CSS
  function loadSwiperCSS() {
    if (!document.querySelector('link[href*="swiper-bundle"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      document.head.appendChild(link);
    }
  }
  
  // Load Swiper JS
  function loadSwiperJS(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = callback;
    document.head.appendChild(script);
  }
  
  // Initialize all sliders
  function initSliders() {
    // Handle both gallery and blog sliders
    const sliderContainers = document.querySelectorAll('.gallery-mobile-swiper, .blog-mobile-swiper');
    
    sliderContainers.forEach((container) => {
      // Skip if already initialized
      if (container.swiper) return;
      
      const swiper = new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        }
      });
      
      swipers.push(swiper);
    });
  }
  
  // Destroy all sliders
  function destroySliders() {
    swipers.forEach(swiper => {
      if (swiper && !swiper.destroyed) {
        swiper.destroy(true, true);
      }
    });
    swipers = [];
  }
  
  // Check width and show/hide appropriate version
  function checkWidth() {
    const width = window.innerWidth;
    
    if (width <= BREAKPOINT) {
      // Mobile - init sliders if not already done
      if (swipers.length === 0 && document.querySelector('.gallery-mobile-swiper, .blog-mobile-swiper')) {
        loadSwiperJS(initSliders);
      }
    } else {
      // Desktop - destroy sliders if they exist
      if (swipers.length > 0) {
        destroySliders();
      }
    }
  }
  
  // Debounce resize
  let resizeTimer;
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkWidth, 250);
  }
  
  // Initialize
  function init() {
    loadSwiperCSS();
    checkWidth();
    window.addEventListener('resize', handleResize);
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Shopify section events (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    destroySliders();
    setTimeout(checkWidth, 100);
  });
  
  document.addEventListener('shopify:section:unload', function() {
    destroySliders();
  });
})();
